import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-horizontal-bar-chart',
  templateUrl: './fc-horizontal-bar-chart.component.html',
  styleUrls: ['./fc-horizontal-bar-chart.component.scss']
})
export class FcHorizontalBarChartComponent implements OnChanges {

  @ViewChild('chartContainer', { static: true }) chartContainer;
  @Output() select = new EventEmitter<any>();
  @Input() results: any[] = [];
  @Input() isLoading = true;
  @Input() showXAxis = true;
  @Input() showYAxis = true;
  @Input() gradient = false;
  @Input() showLegend = true;
  @Input() showXAxisLabel = true;
  @Input() yAxisLabel: string;
  @Input() showYAxisLabel = true;
  @Input() xAxisLabel: string;
  @Input() formatValue: (value: number) => string;
  @Input() tooltipDisabled = false;
  @Input() colors: string[] = [];

  public chartData: any[] = [];

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.results && !changes.results.currentValue.length) || !changes.results) {
      return;
    }

    this.setPercentageOnItem();
    this.reorderChartColumnsDesc();
  }

  public setPercentageOnItem(): void {
    const highestValueItem = this.results.reduce((prev, current) => {
      return (prev.value > current.value) ? prev : current;
    });
    const highestValue = highestValueItem.value;

    this.chartData = this.results.map((result) => {
      const percentage = highestValue ? Math.round((result.value / highestValue) * 100) : 0;
      return { ...result, percentage: percentage };
    });
  }

  private reorderChartColumnsDesc(): void {
    this.chartData.sort((a, b) => b.value - a.value);
  }
}
